const base64Prefix = 'data:image/png;base64';
const pdfExt = '.pdf';

export const isBase64 = (source: string): boolean =>
  source.startsWith(base64Prefix);

export const isPDF = (source: string): boolean =>
  source?.slice(-pdfExt.length).toLowerCase() === pdfExt;
